import type { Map } from 'leaflet'
import { FC, useState } from 'react'
import {
  TopLeftControls,
  LargeMapButton,
  TopControls,
  TopRightControls,
  LeftBottomControls,
  MapButton,
  RightBottomControls,
} from './styles'
import ChevronDownIcon from '../../assets/icons/chevronDown.svg'
import Icon from '../Icon/Icon'
import DrawToolControl from './controls/DrawToolControl'
import { useMapContext } from '../../contexts/map/MapContext'
import PanoramaMenuControl from './controls/PanoramaMenuControl'
import PanoramaCloseButton from './controls/PanoramaCloseButton'
import PanoramaMapMinimizeButton from './controls/PanoramaMapMinimizeButton'
import LegendControl from './controls/LegendControl'
import CloseControl from './controls/CloseControl'
import EmbedControl from './controls/EmbedControl'
import TopoMenu from './controls/TopoMenu'
import ShareMenu from './controls/ShareMenu'
import Topo from '../../assets/icons/topo.svg'
import Share from '../../assets/icons/share.svg'
import { Variant } from '../Button/Button'
import PanoramaViewerInfoBar from '../../../pages/MapPage/components/PanoramaViewer/PanoramaViewerInfoBar'

interface SidebarMapControlsProps {
  map?: Map | null
  isMobile?: boolean
  onCloseMobileMap: () => void
}

const SidebarMapControls: FC<SidebarMapControlsProps> = ({ isMobile, map, onCloseMobileMap }) => {
  const { panoActive, panoFullScreen, panelActive, setShowLargeMap, showLargeMap } = useMapContext()
  const [topoMenu, setTopoMenu] = useState(false)
  const [shareMenu, setShareMenu] = useState(false)

  const toggleLargeMap = () => {
    if (!showLargeMap) {
      setShowLargeMap(true)
    } else {
      setShowLargeMap(false)
    }
  }
  const toggleShareMenu = () => {
    setTopoMenu(false)
    setShareMenu(!shareMenu)
  }
  const toggleTopoMenu = () => {
    setShareMenu(false)
    setTopoMenu(!topoMenu)
  }

  return (
    <>
      {isMobile ? (
        <TopControls spaceBetween>
          <LegendControl />
          {panoActive ? (
            <PanoramaCloseButton />
          ) : (
            <CloseControl onClose={panelActive ? toggleLargeMap : onCloseMobileMap} />
          )}
        </TopControls>
      ) : (
        <>
          <TopLeftControls>
            {panelActive && (
              <LargeMapButton type="button" onClick={toggleLargeMap} size={44}>
                <Icon size={24} rotate={showLargeMap ? 270 : 90}>
                  <ChevronDownIcon />
                </Icon>
              </LargeMapButton>
            )}
          </TopLeftControls>
          <TopControls>
            <LegendControl />
            {panoActive && (
              <>
                <PanoramaMenuControl />
                <PanoramaCloseButton />
              </>
            )}
            <EmbedControl />
          </TopControls>
        </>
      )}
      {!panoActive && <TopRightControls>{map && <DrawToolControl map={map} />}</TopRightControls>}
      <LeftBottomControls $panoActive={panoActive} $smallMap={panoFullScreen}>
        {panoActive ? (
          <PanoramaMapMinimizeButton />
        ) : (
          <>
            <MapButton
              title="Open topografie menu"
              size={isMobile ? 44 : undefined}
              onClick={toggleTopoMenu}
              variant={Variant.PrimaryInverted}
            >
              <Topo />
              {!isMobile && 'Weergaveopties'}
            </MapButton>
            <MapButton
              size={44}
              title="Delen"
              onClick={toggleShareMenu}
              variant={Variant.PrimaryInverted}
            >
              <Share />
            </MapButton>
          </>
        )}
      </LeftBottomControls>
      {panoActive && (
        <RightBottomControls>
          <PanoramaViewerInfoBar />
        </RightBottomControls>
      )}
      {topoMenu && <TopoMenu setTopoMenu={setTopoMenu} />}
      {shareMenu && <ShareMenu setShareMenu={setShareMenu} />}
    </>
  )
}

export default SidebarMapControls
